var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAir = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "xMidYMid meet",
  width: "100%",
  height: "100%",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 19 19",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "flight",
  d: "M4.85575 19V16.9807L7.77875 14.9288V10.9635L0 14.0865V11.6058L7.77875 6.1405V1.72125C7.77875 1.24808 7.94742 0.842916 8.28475 0.50575C8.62192 0.168583 9.027 0 9.5 0C9.973 0 10.3781 0.168583 10.7153 0.50575C11.0526 0.842916 11.2212 1.24808 11.2212 1.72125V6.1405L19 11.6058V14.0865L11.2212 10.9635V14.9288L14.1345 16.9807V19L9.5 17.596L4.85575 19Z",
  fill: "currentColor"
})));
export default __webpack_public_path__ + "static/media/air.c5a8ec6c.svg";
export { SvgAir as ReactComponent };